import React, { useCallback, useContext, useMemo } from 'react'
import { SidenavProps } from '../Korbantech'
import brandLogo from '../assets/logo impulso.svg'
import { uniqueId } from 'lodash'
import { OSC_MENU_ITEMS } from '../utils/constants'
import { useNavigate } from 'react-router-dom'
import SidenavItemOsc from './SideNavItemOsc'
import bg from '../assets/Vector 5.svg'
import OscContext from '../context/Osc'
import { FaUserCircle } from 'react-icons/fa'
import api from '../helpers/api'


export const SideNavOsc = ({ items, userData, brandLogoUrl, bg_color, sideNavUserColor, sideNavUserTextColor, hoverColor,
    hoverText, textColor }: SidenavProps) => {
    
    const {state : user , setState:setUser} = useContext(OscContext)


    const logout = useCallback( async () => {
        if( !user ) return
        const headers = {
            Authorization: `Bearer ${user?.access_token}`
        }
        await api.get( 'client/auth/logout', { headers } ).then( () => {
            setUser( undefined )
            window.location.reload()
        }).catch( console.log )
    }, [ setUser, user ] )
    
    const navigate = useNavigate()

    const menuItems = useMemo(() => {
        return OSC_MENU_ITEMS.map(menu => ({
            ...menu,
            action: () => menu.to && navigate(menu.to)
        }))
    }, [navigate])

    return (
        <div className='h-full w-2/12 top-0 left-0 flex flex-col justify-between bg-primary'>
            <div>
                <div className="flex w-full my-5 justify-center mx-auto ">
                    <img className="" height="auto" src={brandLogo} alt="brand-logo" />
                </div>
                <div className="flex flex-col items-center gap-y-3 w-full justify-center overflow-visible px-2">
                    {
                        menuItems?.map(item => (

                            <SidenavItemOsc key={uniqueId()} {...item} img={item.img} />

                        ))
                    }
                </div>
            </div>
            <div className='flex p-4 gap-x-3' style={{
                backgroundImage:`url("${bg}")`
            }}>
             <div className='h-12 w-12 rounded-full bg-gray-200 flex justify-center items-center'>
                 {user?.logo  && <img src={user.logo} alt="avatar"/>}
                 {!user?.logo &&  <FaUserCircle  className='text-5xl text-gray-500' />}
             </div>
             <div className='flex flex-col justify-center'>
                <div className='text-white text-sm'>{user?.corporate_name}</div>
                <div className='text-primary text-sm cursor-pointer'
                    onClick={logout}
                >Sair</div>
             </div>
            </div>
        </div>
    )
}